import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import {MessageService} from 'primeng/api';
import { CommonService } from './common.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { DocumentService } from './document.service';

declare var webengage
@Injectable({
  providedIn: 'root'
})

export class AuthService {
  user:any
  documents = []
  constructor(public http:HttpClient,public router:Router,private messageService: MessageService,public common:CommonService, public angularFireAuth : AngularFireAuth, private documentService : DocumentService) {
    if(localStorage.getItem("access_token")){
      this.user=JSON.parse(localStorage.getItem("user"))
      this.setUser()

    }
  }

  register(registerForm){
    // logic for registration and set user variable
    this.http.post(environment.api_link+'/api/auth/signUp',registerForm).subscribe((res:any)=>{
      //console.log(res)
      if(res.access_token && res.token_type){
        localStorage.setItem("access_token",res.access_token)
        this.setUser()
        this.router.navigateByUrl("/verify-email")
      }
      this.common.stopLoader()
    },err=>{
      /* alert(err.error.message) */
      let errorKeys = Object.keys(err.error.errors);
      errorKeys.forEach(key => {
        //console.log(key)
        let value = err.error.errors[key][0];
        this.messageService.add({severity:'error', summary:value, detail:""});
        //console.log(value);
    });
      //console.log(err)
      this.common.stopLoader()
    })
  }

  signin(email,password){
    // signin methid implementation
    this.common.showLoader()
    this.http.post(environment.api_link+'/api/auth/login',{email:email,password:password}).subscribe(async (res:any)=>{

      if(res.return){
        localStorage.setItem("access_token",res.data.access_token)
        this.router.navigateByUrl("/dashboard")
        await this.setUser()
        webengage.track("login_existing_user", {
          "Name" : `${this.user?.name?this.user?.name:''} ${this.user?.lastname?this.user?.lastname:''}`,
          "Country" : this.user?.country_id || 0,
          "State" : this.user?.state_id || 0,
          "Phone" : this.user?.mob_num || 0,
          "Is_verified" : this.user?.verified 
        });
      }
      else if(!res.return){
        this.common.stopLoader()
        this.messageService.add({severity:'error',summary:res.message})
      }
      else{
        this.messageService.add({severity:'error', summary:res.message, detail:""});
      }
      this.common.stopLoader()
    },err=>{
      if(!err.error.status){
        this.messageService.add({severity:'error', summary:'Please check your email or password', detail:""});
      }
      this.common.stopLoader()
    })

  }

  forgetPassword(){
    // send reset password email
  }

  logout(){
    localStorage.removeItem("access_token")
    localStorage.removeItem("user")
    localStorage.removeItem('lims')

    this.router.navigateByUrl("/signin")
    location.reload()
    this.http.post(environment.api_link+"/api/auth/logout",{}).subscribe(res=>{
    },err=>{
      let errorKeys = Object.keys(err.error.errors);
      errorKeys.forEach(key => {
        let value = err.error.errors[key][0];
        this.messageService.add({severity:'error', summary:value, detail:""});
    });
    })
    this.angularFireAuth.signOut()
    webengage.track("user_logged_out", {
      "User Id" : this.user.id
    });
  }

  logoutWithoutRedirect(){
    localStorage.removeItem("access_token")
    localStorage.removeItem("user")
    localStorage.removeItem('lims')
    location.reload()

    this.http.post(environment.api_link+"/api/auth/logout",{}).subscribe(res=>{

    },err=>{
      let errorKeys = Object.keys(err.error.errors);
      errorKeys.forEach(key => {
        let value = err.error.errors[key][0];
        this.messageService.add({severity:'error', summary:value, detail:""});
    });
      //console.log(err)
    })
    this.angularFireAuth.signOut()
    webengage.track("user_logged_out", {
      "User Id" : this.user.id
    });
  }

  isAuthenticated(){
     // return true and false depending on user's login status
     if(localStorage.getItem("access_token")){
       return true
     }else{
       return false
     }
  }
  getUserDocuments(){
    this.documentService.getDocumentList().subscribe((res:any) => {
      this.documents = res.user_documents
    })
  }
  async setUser(){
    await this.http.post(environment.api_link+'/api/auth/me',{}).subscribe((res:any)=>{
      // console.log(res)
      this.user=res.data
      localStorage.setItem("user",JSON.stringify(this.user))
      if(this.user.email_verified_at && this.user.verified)
         this.get_monthly_limit(res.data.id)
      else if(!this.user.email_verified_at){
        this.router.navigateByUrl("/verify-email")
      }
      else if(!this.user.mob_verified && !this.user.verified){
       this.router.navigateByUrl("/account")
      }
      else if(this.user.country_id==233 && !this.user.verified){
       this.router.navigateByUrl("/account")
      }
      else if(this.user.country_id==39 && !this.user.mob_verified && !this.user.verified){
        this.router.navigateByUrl("/account")
       }
      // else if(this.user.country_id==39 && this.user.mob_verified){
      //   this.router.navigateByUrl("/dashboard")
      // }
    },err=>{
      this.messageService.add({'severity':'error', detail:'Something went wrong!'})
      this.router.navigateByUrl("/signin")
      this.logout()
    })
  }
  resendVerificationLink(){
    return this.http.post(environment.api_link+'/api/auth/me',{})
  }

  sendOTP(data:{mob_num:number, phone_code:number}){
    return this.http.post(environment.api_link+'/api/auth/sendOtp',data)
  }

  verifyOTP(data:{mob_num:number,otp:number, phone_code:number}){
    return this.http.post(environment.api_link+'/api/auth/verifyOtp',data)
  }

  updateUser(data){
    return this.http.post(environment.api_link+'/api/auth/updateUser',data)
  }

  getStates(country_id){
    return this.http.post(environment.api_link+'/api/auth/states',{country_id : country_id})
  }

  getWidgetToken(){
    return this.http.post(environment.api_link+'/api/auth/widget_token',{})
  }

  resetPassword(data){
    return this.http.post(environment.api_link+'/api/forgot_password',data)
  }
  resendverify(){
    return this.http.get(environment.api_link+"/api/auth/resend_verify_email")
  }

  getTermsCA(name,email){
    return this.http.post(environment.api_link+"/api/get_terms_content",{name:name,email:email})
  }

  resendEmail(){
    return this.http.get(environment.api_link+"/api/auth/resend_verify_email")
  }

  verifyUser(){
    return this.http.post(environment.api_link+"/api/auth/verify",{status:1})
  }

  getTransactions(page = 1){
    return this.http.get(environment.api_link+"/api/auth/get_transaction?page="+page)
  }

  getReferLink(){
    return this.http.get(environment.api_link+"/api/auth/generate-refer-link")
  }

  sendReferEmail(email){
    return this.http.post(environment.api_link+"/api/auth/save-refer-user",{email:email})
  }

  changePassword(data){
    return this.http.post(environment.api_link+"/api/auth/change_password",data)
  }

  resetPasswordWithToken(data){
    return this.http.post(environment.api_link+"/api/password/reset",data)
  }

  getMoneyRequests(){
    return this.http.get(environment.api_link+"/api/auth/get_user_requests")
  }

  requestAction(data){
    return this.http.post(environment.api_link+"/api/auth/change_request_status",data)
  }
  fipartners(name){
    return this.http.get(environment.api_link+"/api/auth/get_fipartners_details/"+name)
  }

  get_monthly_limit(id){
    this.http.get(`${environment.api_link}/api/auth/check-monthly-limit/${id}`).subscribe((res:any) => {
      this.common.max_limit_monthly = res.data.mtl
      this.common.max_limit_daily = res.data.dl
      this.common.max_left_monthly = res.data.mtll
      this.common.max_left_daily = res.data.dll
      localStorage.setItem('lims',`
      {
        mtl : ${res.data.mtl},
        mtll : ${res.data.mtll},
        dl : ${res.data.dl},
        dll : ${res.data.dll}
      }
      `)
    }, err => {
      //console.log(err)
      this.logout()
    })
  }
}
